export const listMeterReadings = `
   query listMeterReadings($filter: MeterReadingsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listMeterReadings(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
                id
                customerId
                meterId
                meterValue
                timestamp
                dimensions {
                    apiKey
                    value
                }
                created
                updated
           }
           nextToken
       }
   }
`;

export const getMeterReading = `
   query getMeterReading($id:ID!) {
       getMeterReading(id:$id) {
                id
                customerId
                meterId
                meterValue
                timestamp
                dimensions {
                    apiKey
                    value
                }
                created
                updated
       }
}`;
